(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const ElementIds = {
    desktopCartDrawerOpenBtn: "desktopCartDrawerOpenBtn",
    mobileCartDrawerOpenBtn: "mobileCartDrawerOpenBtn",
    mobileMenuDialog: "mobileNavMenuDialog",
    mobileMenuCloseImg: "mobileMenuCloseImg",
    mobileMenuOpenImg: "mobileMenuOpenImg",
    mobileMenuCloseBtn: "mobileMenuCloseBtn",
    mobileMenuOpenBtn: "mobileMenuOpenBtn",
  };

  const ElementClassNames = {
    desktopNav: "desktop__nav",
    mobileNav: "mobile__nav",
    navBranding: "nav-branding",
    navBrandingScrolled: "nav-branding__scrolled",
  }

  document.addEventListener("DOMContentLoaded", () => {
    const desktopCartDrawerCloseBtn = document.getElementById(ElementIds.desktopCartDrawerCloseBtn);
    const desktopCartDrawerOpenBtn = document.getElementById(ElementIds.desktopCartDrawerOpenBtn);

    const mobileCartDrawerCloseBtn = document.getElementById(ElementIds.mobileCartDrawerCloseBtn);
    const mobileMenuDialog = document.getElementById(ElementIds.mobileMenuDialog);
    const mobileMenuCloseImg = document.getElementById(ElementIds.mobileMenuCloseImg);
    const mobileMenuCloseBtn = document.getElementById(ElementIds.mobileMenuCloseBtn);
    const mobileMenuOpenBtn = document.getElementById(ElementIds.mobileMenuOpenBtn);
    const mobileMenuOpenImg = document.getElementById(ElementIds.mobileMenuOpenImg);

    const settings = {
      htmlOverflow: document.body.parentElement.style.overflow
    };

    function openCart() {
      document.dispatchEvent(openCartEvent);
    }

    desktopCartDrawerOpenBtn.addEventListener("click", openCart);
    mobileCartDrawerOpenBtn.addEventListener("click", openCart);

    mobileMenuCloseBtn.addEventListener("click", () => {
      mobileMenuDialog.close();
    });

    mobileMenuOpenBtn.addEventListener("click", openMenu);

    mobileNavMenuDialog.addEventListener("close", () => {
      mobileMenuOpenBtn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "unset";
      document.body.parentElement.style.overflow = settings.htmlOverflow;
    });

    function openMenu() {
      mobileNavMenuDialog.showModal();
      mobileMenuOpenBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      document.body.parentElement.style.overflow = "unset";
    }

    function swapBranding() {
      const navBranding = Array.from(document.getElementsByClassName(ElementClassNames.navBranding));
      const navBrandingScrolled = Array.from(document.getElementsByClassName(ElementClassNames.navBrandingScrolled));
      
      const desktopNav = Array.from(document.getElementsByClassName(ElementClassNames.desktopNav))[0]
      const mobileNav = Array.from(document.getElementsByClassName(ElementClassNames.mobileNav))[0]

      const { y } = document.body.getClientRects()[0];
      
      if (y < -100) {
        desktopNav.classList.add("scrolled");
        mobileNav.classList.add("scrolled");
        navBranding.forEach(img => img.style.display = "none");
        navBrandingScrolled.forEach(img => img.style.display = "block");
      } else {
        desktopNav.classList.remove("scrolled");
        mobileNav.classList.remove("scrolled");
        navBranding.forEach(img => img.style.display = "block");
        navBrandingScrolled.forEach(img => img.style.display = "none");
      }
    }

    const swapBrandingDebounce = new Debounce({ leading: true, timeout: 100 });

    document.addEventListener("scroll", (e) => {
      swapBrandingDebounce.trigger(swapBranding);
    });

    swapBranding();
  });

  class Debounce {
    #id;
    #timeout = 100;

    #isLeading = false
    #leadingBlocked = false;
    #queuedCallback = undefined;

    constructor({ timeout = 100, leading = false } = { timeout: 100, leading: false }) {
      this.#timeout = timeout;
      this.#isLeading = leading;
    }

    trigger(callback) {
      if (!this.#isLeading) {
        clearTimeout(this.#id);
        this.#id = setTimeout(() => {
          callback();
        }, this.#timeout);
      } else {
        this.#queuedCallback = callback;
        this.#triggerLeading();
      }
    }

    #triggerLeading() {
      if (!this.#leadingBlocked && this.#queuedCallback) {
        this.#leadingBlocked = true;

        this.#queuedCallback();
        this.#queuedCallback = undefined;

        setTimeout(() => {
          this.#leadingBlocked = false;
          this.#triggerLeading();
        }, this.#timeout);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const ElementIds = {  
    ProductLoadingOverlay: "productLoadingOverlay",
  };

  const ElementClassNames = {
    ProductCarouselImage: "product__carousel__image-container",
    ProductCarouselViewer: "product__carousel-viewer",
    ProductCarouselViewerImageContainer: "product__carousel-viewer__image-container",
    ProductDetailsForm: "product__details",
    ProductDetailsOptionRadioInput: "product__details-option__radio-input",
    ProductDetailsPriceDisplay: "product__details-header__price",
    ProductDetailsSectionError: "product__details-section__error",
    ProductDetailsSectionErrorMessage: "product__details-section__error-message",
    ProductDetailsSectionHeader: "product__details-section__header",
    ProductDetailsSectionOptionsContainer: "product__details-section__options-container",
  };

  const settings = {
    selection: {},
    variantId: undefined,
  };

  function getMobileProductCarouselViewerImageContainer() {
    const mobileProductCarouselViewer = Array.from(document.getElementsByClassName(ElementClassNames.ProductCarouselViewer))
        ?.find(el => el.classList.contains("mobile"));
    if (mobileProductCarouselViewer) {
      const container = Array.from(mobileProductCarouselViewer.getElementsByClassName(ElementClassNames.ProductCarouselViewerImageContainer))[0];
      return container;
    }
  }

  function getDesktopProductCarouselViewerImageContainers() {
    const mobileProductCarouselViewer = Array.from(document.getElementsByClassName(ElementClassNames.ProductCarouselViewer))
        ?.find(el => el.classList.contains("desktop"));
    if (mobileProductCarouselViewer) {
      const container = Array.from(mobileProductCarouselViewer.getElementsByClassName(ElementClassNames.ProductCarouselViewerImageContainer));
      return container;
    }
  }

  document.addEventListener("DOMContentLoaded", async () => {
    const desktopProductCarouselViewer = Array.from(document.getElementsByClassName(ElementClassNames.ProductCarouselViewer)).find(el => el.classList.contains("desktop"));
    const mobileProductCarouselViewerImageContainer = getMobileProductCarouselViewerImageContainer();
    const desktopProductCarouselViewerImageContainers = getDesktopProductCarouselViewerImageContainers();
    const productCarouselImages = Array.from(document.getElementsByClassName(ElementClassNames.ProductCarouselImage));
    const productOptionRadioInputs = Array.from(document.getElementsByClassName(ElementClassNames.ProductDetailsOptionRadioInput));
    const priceElement = Array.from(document.getElementsByClassName(ElementClassNames.ProductDetailsPriceDisplay))[0];
    const productDetailsForm = Array.from(document.getElementsByClassName(ElementClassNames.ProductDetailsForm))[0];
    const productDetailsSectionError = Array.from(document.getElementsByClassName(ElementClassNames.ProductDetailsSectionError))[0];
    const productDetailsSectionErrorMessage = Array.from(document.getElementsByClassName(ElementClassNames.ProductDetailsSectionErrorMessage))[0];
    const productDetailsLoading = document.getElementById(ElementIds.ProductLoadingOverlay);

    productCarouselImages.forEach(image => {
      image.addEventListener("click", (e) => {
        unselectCarouselImage(productCarouselImages);
        selectCarouselImage(image);
        replaceCarouselViewerImage(image, mobileProductCarouselViewerImageContainer);
        scrollCarouselImage(image, desktopProductCarouselViewer);
      });
    });

    function handleCarouselIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          unselectCarouselImage(productCarouselImages);
          const intersectedImg = Array.from(entry.target.getElementsByTagName("img"))[0];
          const selectedCarouselImage = productCarouselImages.find(c => Array.from(c.getElementsByTagName("img"))[0]?.src === intersectedImg?.src);
          selectCarouselImage(selectedCarouselImage);
          replaceCarouselViewerImage(selectedCarouselImage, mobileProductCarouselViewerImageContainer);
        }
      })
    }

    const desktopCarouselIntersectionObserver = new IntersectionObserver(
      handleCarouselIntersection, 
      {
        threshold: 0.6
      }
    );

    desktopProductCarouselViewerImageContainers.forEach(c => {
      desktopCarouselIntersectionObserver.observe(c)
    });

    productOptionRadioInputs.forEach(radio => {
      if (radio.checked) {
        settings.selection[radio.name] = radio.value;
      }

      radio.addEventListener("change", async (e) => {
        hideError();

        const element = e.currentTarget;
        if (element.checked) {
          updateDetailSelection(element);
          settings.selection[element.name] = element.value;
          const variant = await getSelectedVariant(settings.selection, _variants, _options);
          settings.variantId = variant?.id;
          updatePrice(variant, priceElement);
        }
      })
    });

    Array.from(productDetailsForm.getElementsByTagName("button")).forEach(button => {
      if (button.type !== "reset") {
        button.addEventListener("click", onAddProduct);
      }
    });

    productDetailsForm.addEventListener("submit", onAddProduct);

    const variant = await getSelectedVariant(settings.selection, _variants, _options);
    settings.variantId = variant?.id;
    updatePrice(variant, priceElement);

    function enableLoadingOverlay() {
      document.body.style.overflow = "hidden";
      productDetailsLoading.style.display = "flex";
    }

    function disableLoadingOverlay() {
      productDetailsLoading.style.display = "none";
      document.body.style.overflow = "unset";
    }

    function hideError() {
      productDetailsSectionError.style.display = "none";
      productDetailsSectionErrorMessage.innerHTML = "";
    }

    function showError(message) {
      productDetailsSectionError.style.display = "block";
      productDetailsSectionErrorMessage.innerHTML = message;
    }

    async function onAddProduct(e) {
      if (settings.variantId) {
        e.preventDefault();
        enableLoadingOverlay();
        await submitProductSelection(settings.variantId);
        disableLoadingOverlay();
      }
    }

    async function submitProductSelection(variantId) {
      const data = {
        id: variantId?.toString(),
        quantity: 1,
        sections: ["header"],
        sections_url: window.location.pathname
      };

      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      })
      .then(async response => {
        if (!response.ok) {
          const statusText = response.statusText;
          const bodyText = await response.text();
          throw new Error(bodyText || statusText);
        } else {
          return response.json()
        }
      })
      .then(data => {
        console.log('Item added to cart:', data);
        if (data?.sections?.header) {
          SectionRenderer.render(".desktop__nav__cart-button", data.sections.header);
          SectionRenderer.render(".mobile__nav__cart-button", data.sections.header);
          SectionRenderer.render(".cart-drawer__list", data.sections.header);
          SectionRenderer.render(".cart-drawer__checkout-total", data.sections.header);
        }
        
        if (data.errors) {
          showError(data.errors);
        } else {
          hideError();
        }
      })
      .catch((error) => {
        console.error('Error adding item to cart:', error);
        showError(error.message);
      });
    }

    /**
     * @param { { options: string[]; price: number; id: string; } } selected variant
     * @param {HTMLElement} priceElement
     */
    function updatePrice(variant, priceElement) {
      if (variant) {
        const value = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(variant.price / 100);
        priceElement.textContent = value;
      } else {
        priceElement.textContent = "";
      }
    }

    /**
     * @param {Record<string, string>} selection the user's current option selections (option key: option value)
     * @param { { options: string[]; }[] } variants all variants
     * @param { { position: number; }[] } options possible options
     * 
     * @returns { { price: number; id: string; } } selected variant
     */
    async function getSelectedVariant(selection, variants, options) {
      const selectedOptions = [];

      Object.entries(selection).forEach(([name, value]) => {
        const position = options.find(opt => opt.name === name).position;
        const index = position - 1;
        selectedOptions[index] = { name, value };
      });

      let variant = variants.find(v => {
        const variantOptions = v.options || [];
        if (variantOptions.length === selectedOptions.length) {
          return v.options.every((opt, index) => selectedOptions[index].value === opt);
        }
        return false;
      });

      if (!variant) {
        variant = await fetchSelectedVariant(selectedOptions);
      } 

      return variant;
    }

    async function fetchSelectedVariant(selectedOptions) {
      let variant = undefined;

      enableLoadingOverlay();

      const query = `
        query getVariantBySelection($handle: String!, $selectedOptions: [SelectedOptionInput!]!) {
          product(handle: $handle) {
            selectedOrFirstAvailableVariant(selectedOptions: $selectedOptions) {
              id
              price {
                amount
                currencyCode
              }
            }
          }
        }
      `;
      
      const variables = { handle: _product.handle, selectedOptions };

      const response = await fetch(window.Shopify.routes.root + 'api/2026-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query,
          variables
        })
      })

      if (!response.ok) {
        const statusText = response.statusText;
        const bodyText = await response.text();
        showError(bodyText || statusText);
      } else {
        const parsedResponse = await response.json();
        if ("errors" in parsedResponse && Array.isArray(parsedResponse.errors)) {
          const errors = parsedResponse.errors.map(({ message }) => message).join(". ");
          showError(errors);
        } else if ("data" in parsedResponse && parsedResponse.data.product.selectedOrFirstAvailableVariant) {
          const data = parsedResponse.data.product.selectedOrFirstAvailableVariant;
          variant = {
            ...data, 
            // get numerical portion of id
            id: Number(data.id.split("/").pop()), 
            // price is in dollars, we need in cents
            price: Number(data.price?.amount) * 100 
          };
        } else {
          showError("No variant found");
        }
      }

      disableLoadingOverlay();

      return variant;
    }

    /**
     * @param {HTMLElement[]} carouselImages
     */
    function unselectCarouselImage(carouselImages) {
      carouselImages.forEach(image => {
        if (image.classList.contains("selected")) {
          image.classList.remove("selected");
          image["aria-selected"] = undefined;
        }
      })
    }

    /**
     * @param {HTMLElement} selectedCarouselImage 
     */
    function selectCarouselImage(selectedCarouselImage) {
      if (!selectedCarouselImage.classList.contains("selected")) {
        selectedCarouselImage.classList.add("selected");
        selectedCarouselImage["aria-selected"] = "true";
      }
    }

    /**
     * @param {HTMLElement} selectedCarouselImage
     * @param {HTMLElement} mobileCarouselImageViewer
     */ 
    function replaceCarouselViewerImage(selectedCarouselImage, mobileCarouselImageViewer) {
      const sourceImg = Array.from(selectedCarouselImage.getElementsByTagName("img"))[0];
      const destinationImg = Array.from(mobileCarouselImageViewer.getElementsByTagName("img"))[0];
      destinationImg.src = sourceImg.src;
      destinationImg.alt = sourceImg.alt;
    }

    /**
     * @param {HTMLElement} selectedCarouselImage
     * @param {HTMLElement} desktopCarouselImageViewer
     */ 
    function scrollCarouselImage(selectedCarouselImage, desktopCarouselImageViewer) {
      const sourceImg = Array.from(selectedCarouselImage.getElementsByTagName("img"))[0];
      const destinationImg = Array.from(desktopCarouselImageViewer.getElementsByTagName("img")).find(img => img.src === sourceImg.src);
      destinationImg.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }

    /**
     * @param {HTMLElement} radioInputSelection
     */
    function updateDetailSelection(radioInputSelection) {
      const value = radioInputSelection.value;
      const textContent = radioInputSelection.parentNode.textContent.trim();

      let container = radioInputSelection.parentElement;
      let containerFound = false;

      while (container && !containerFound) {
        if (container.classList.contains(ElementClassNames.ProductDetailsSectionOptionsContainer)) {
          containerFound = true;
        } else {
          container = container.parentElement;
        }
      }

      if (!container || !containerFound) {
        throw new Error("Parent node not found for element". radioInputSelection);
      }

      const header = Array.from(container.getElementsByClassName(ElementClassNames.ProductDetailsSectionHeader))[0];
      const description = Array.from(header.getElementsByTagName("p"))[0];
      description.textContent = textContent;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
